import { clsx } from "clsx";
import { useState } from "react";

import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "common/components/ui/Dialog";
import {
  Drawer,
  DrawerContent,
  DrawerTrigger,
} from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { AppSumoPromotion, LTDPromotion } from "common/types";

import Promotion from "./Promotion";

export default function ManagePromotion({
  promotion,
}: {
  promotion: AppSumoPromotion | LTDPromotion;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const isDesktop = useTwBreakpoint("lg");

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;
  const Trigger = isDesktop ? DialogTrigger : DrawerTrigger;

  const promotionName =
    promotion.type === "appsumo" ? "AppSumo" : "lifetime deal";

  return (
    <Component open={isOpen} onOpenChange={setIsOpen}>
      <Trigger asChild>
        <Button
          variant={
            promotion.type === "appsumo" ? "secondary-black" : "default-black"
          }
          className={clsx(
            "max-lg:flex-1",
            promotion.type === "appsumo" && "bg-appsumoYellow",
          )}
          size={isDesktop ? "sm" : "md"}
        >
          Manage {promotionName}
        </Button>
      </Trigger>
      <Content>
        <Promotion promotion={promotion} onClose={() => setIsOpen(false)} />
      </Content>
    </Component>
  );
}
